export const timelineData = {
    thursday: {
        name: 'Thursday',
        date: '19/10/20',
        events: [
            {
                name: 'Opening Ceremony',
                time: '9:00',
                owner: 'HTM Team',
            },
            {
                name: 'Team Building',
                time: '10:00',
                owner: 'HTM Team',
            },
            {
                name: 'Start of Hacking',
                time: '11:00',
                owner: 'HTM Team',
            },
            {
                name: 'Event 4',
                time: '12:00',
                owner: 'HTM Team',
            },
            {
                name: 'Event 5',
                time: '13:00',
                owner: 'HTM Team',
            },
            {
                name: 'Event 6',
                time: '14:00',
                owner: 'HTM Team',
            },
            {
                name: 'Event 6 with a title',
                time: '17:00',
                owner: 'HTM Team',
            },
            {
                name: 'Event 7',
                time: '18:00',
                owner: 'HTM Team',
            },
            {
                name: 'Last Event',
                time: '23:00',
                owner: 'HTM Team',
            },
        ],
    },
    friday: {
        name: 'Friday',
        date: '20/10/20',
        events: [
            {
                name: 'Event 8 with a really long title that cuases the card to overflow',
                time: '9:00',
                owner: 'HTM Team',
            },
            {
                name: 'Event 9',
                time: '10:00',
                owner: 'HTM Team',
            },
            {
                name: 'Event 10',
                time: '11:00',
                owner: 'HTM Team',
            },
        ],
    },
};
